export default __webpack_public_path__ + "static/media/Brotherhood.1d243a88.jpg";